import { TextField } from "@mui/material"
import * as React from "react"
import { useGridApiContext } from "@mui/x-data-grid"
import { rootStore } from "stores/root-store"
import VirtualizedAutocomplete from "./virtualized-autocomplete"

const AutocompleteEditInputCell = ({ id, value, field, hasFocus, options }) => {
  const apiRef = useGridApiContext()
  const ref = React.useRef()

  const handleChange = (event, newValue) => {
    apiRef.current.setEditCellValue({ id, field, value: newValue })
    apiRef.current.stopCellEditMode({ id, field })
  }

  React.useLayoutEffect(() => {
    if (hasFocus && ref.current) {
      ref.current.focus()
      const input = ref.current.querySelector(`input`)
      input?.focus()
      input?.select()
    }
  }, [hasFocus])

  return (
    <VirtualizedAutocomplete
      ref={ref}
      value={rootStore.getTextByValue("COUNTRY", value)}
      onChange={(event, item) => handleChange(event, item.id)}
      options={options}
      renderInput={params => <TextField {...params} />}
    />
  )
}

export default AutocompleteEditInputCell
